import React from "react";
import { PeekStack } from "@piiqtechnologies/ui-components";
import { useIntl } from "react-intl";
import CustomSubtitle from "../CustomSubtitle";
import MultipleCommunitySelector from "./MultipleCommunitySelector";
import messages from "./messages.i18n";
const fieldValue = "communities";
export const SettingsCommunities = ({ form }) => {
    const intl = useIntl();
    const handleSelectCommunities = (communityIds) => {
        // @ts-ignore
        form.setFieldValue(fieldValue, communityIds);
    };
    return (React.createElement(PeekStack, { spacing: 0.25 },
        React.createElement(CustomSubtitle, { subtitle: intl.formatMessage(messages.communitiesViewLabel) }),
        React.createElement(MultipleCommunitySelector, { label: "", form: form, onSelect: handleSelectCommunities, field: { name: fieldValue }, placeholder: intl.formatMessage(messages.communitiesSelectPlaceholder) })));
};
export default SettingsCommunities;
